import { actionChannel, put, putResolve, select, take } from 'redux-saga/effects';

import type { SagaIterator } from '@redux-saga/types';

import { login } from 'app/redux/actions/auth';

import { checkAvailability, refreshAvailability } from '../actions';
import { PROCESS_STAKES_COMPLETE, ProcessStakesComplete } from '../actions/submission';
import { selectBets } from '../selectors/entries';
import { AvailabilityStakesDAO } from '../types/backend/availableStakes';
import { EntriesBets } from '../types/entries';
import { getAvailabilityResult } from '../utils/availability-saga';
import { getAvailabilityPayload } from './checkAvailability';

// ---

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LoginSuccess = any; // TODO: поменять, как только сделают .ts
type SagaActions = LoginSuccess | ProcessStakesComplete;

export default function* refreshAvailabilitySaga(): SagaIterator {
  const channel = yield actionChannel([
    PROCESS_STAKES_COMPLETE,    // Нужно пересчитать лимиты, возможно, это уже крупная ставка
    login.fulfilled.toString(), // Нужно пересчитать лимиты. У разлогиненного пользователя они отсутствуют.
  ]);

  while (true) {
    const action: SagaActions = yield take(channel);

    const bets: EntriesBets = yield select(selectBets);

    if (bets.size <= 0) {
      continue;
    }

    if (action.type === PROCESS_STAKES_COMPLETE && action.payload.body !== null) {
      const results = getAvailabilityResult(bets, action.payload.body);

      yield put(refreshAvailability(results));
      continue;
    }

    try {
      const payload = getAvailabilityPayload(bets);

      const response: {
        payload: {
          data: AvailabilityStakesDAO;
        };
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
      } = yield putResolve(checkAvailability(payload));

      const results = getAvailabilityResult(bets, response.payload.data);

      yield put(refreshAvailability(results));
    }
    catch (error) {
      console.error(`refreshAvailabilitySaga -> ${error}`);
    }
  }
}
